import { useEffect, useState } from 'react'
import { AddressLookupSelectedAddress, IField } from '@eventr/common'
import { useEditSectionContext } from '../editSectionProvider'
import { BaseAddressPage } from './baseAddressPage'

interface IAddressPageProps {
    _id?: string
    field: IField
}
export const AddressPage = ({ _id, field }: IAddressPageProps) => {
    const { getValue, updateValues } = useEditSectionContext()

    const [val, setVal] = useState<AddressLookupSelectedAddress | undefined>()

    useEffect(() => {
        const initFieldValue = getValue(field, _id)

        if (
            typeof initFieldValue !== 'string' &&
            initFieldValue !== null &&
            typeof initFieldValue !== 'number'
        ) {
            setVal(initFieldValue)
        } else {
            setVal(initFieldValue ?? undefined)
        }
    }, [field, _id, getValue])

    return (
        <BaseAddressPage
            value={val}
            onSave={(val) => {
                updateValues({
                    value: val,
                    field: field,
                    _id: _id,
                })
            }}
        />
    )
}
